import { makeImmutable } from "../../core";
export class CustomParameterPackagingFeeRequirement {
    constructor(params) {
        this.customParameterTypeId = params.customParameterTypeId;
        this.customParameterChoiceIds = params.customParameterChoiceIds;
        makeImmutable(this);
    }
    testProduct(productInstance) {
        return this.customParameterChoiceIds.some((customParameterChoiceId) => productInstance.matchesCustomParameterValue(this.customParameterTypeId, customParameterChoiceId));
    }
    testModifier(_modifierInstance, _modifierItemTypeId) {
        return false;
    }
}
